// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verify-email-address {}

.verify-email-address .verify-button {
	cursor: pointer;
	margin: 14px 16px;
	font-size: 17px;
	color: #C35353;
	font-weight: bold;
	position: relative;
}

.verify-email-address .verify-button .fa {
	position: absolute;
	right: 0;
	top: 1px;
	font-size: 21px;
}


.verify-email-address .mdh-alert {
	color: #000;
	line-height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Dashboard/VerifyEmailAddress.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;CACC,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,QAAQ;CACR,eAAe;AAChB;;;AAGA;CACC,WAAW;CACX,iBAAiB;AAClB","sourcesContent":[".verify-email-address {}\n\n.verify-email-address .verify-button {\n\tcursor: pointer;\n\tmargin: 14px 16px;\n\tfont-size: 17px;\n\tcolor: #C35353;\n\tfont-weight: bold;\n\tposition: relative;\n}\n\n.verify-email-address .verify-button .fa {\n\tposition: absolute;\n\tright: 0;\n\ttop: 1px;\n\tfont-size: 21px;\n}\n\n\n.verify-email-address .mdh-alert {\n\tcolor: #000;\n\tline-height: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
